export default __webpack_public_path__ + "static/media/TRUCKER.169d534f.jpg";